/**
 * CostColumnConfiguration содержит конфигурацию для колонки стоимость.
 * Данный функционал по сути универсален для разных шаблонов таблиц.
 */
export class CostColumnConfiguration {
  /**
   * DisplayText выводит текст в колонке стоимости, если не настроен
   * вывод значения полей или он отключен.
   */
  public DisplayText: string = "-"

  /**
   * Флаг позволяет вывести значения полей, вместо предустановленного текста
   * Если флаг включен, то производится попытка получить значения полей
   * из PriceFieldCode и CurrencyFieldCode. Если значения полей получить
   * не удалось, то будет выведен исходный текст.
   */
  public IsNeedDisplayFieldValues: boolean = false

  /**
   * PriceFieldCode содержит символьный код поля для отображения стоимости в
   * колонке "Стоимость". Отвечает за значение стоимости.
   * Обязательно для указания в шаблоне. Без него колонка будет работать не
   * правильно.
   */
  public PriceFieldCode: string = ""

  /**
   * CurrencyFieldCode содержит символьный код поля для отображения валюты
   * в колонке "Стоимость". Отвечает за вывод валюты.
   * Обязательно для указания в шаблоне. Без него колонка будет работать не
   * правильно.
   */
  public CurrencyFieldCode: string = ""

  /**
   * PricePrefix содержит локализованный префикс для поля стоимости.
   */
  public PricePrefix: string = ""

  /**
   * IsPriceFieldsEditable позволяет сделать поля стоимости в колонке редактируемыми.
   * Пользователь сможет изменять эти поля. Если включить этот флаг, то поля не будут
   * выводиться в колонке количества. Для того чтобы поля были доступны для редактирования,
   * они должны быть видимыми.
   */
  public IsPriceFieldsEditable: boolean = false


  /**
   * Заглушка для запрета прямого создания объектов данного типа
   * @private
   */
  private constructor() {
  }

  /**
   * RestoreSettings выполняет восстановление данных объекта настроек
   * Функция выполняет нормализацию значений настроек.
   * Функция дополняет недостающие настройки значениями по умолчанию.
   *
   * @param data
   */
  public static RestoreSettings(data: any): CostColumnConfiguration {
    let result = new CostColumnConfiguration();

    if (typeof data === "string") {
      data = JSON.parse(data)
    }

    if (typeof data !== "object") {
      return result;
    }

    Object.keys(result).map((key: keyof CostColumnConfiguration) => {
      // @ts-ignore
      result[key] = CostColumnConfiguration.GetCorrectFieldValue(key, data[key])
    })

    return result;
  }

  /**
   * GetCorrectFieldValue выполняет восстановление данных поля из переданного значения настроек.
   * Данный метод так же проводит валидацию значения каждой из настроек поля. Метод возвращает
   * значение по умолчанию, если значение передано не корректно.
   */
  public static GetCorrectFieldValue<T extends keyof CostColumnConfiguration>(field: T, data: any): any {
    let defaults = new CostColumnConfiguration()

    if (data === undefined) {
      return defaults[field]
    }

    switch (field) {
      case "IsNeedDisplayFieldValues":
      case "IsPriceFieldsEditable":
        return !!data
      case "DisplayText":
      case "PricePrefix":
      case "PriceFieldCode":
      case "CurrencyFieldCode":
        return typeof data === "string" ? data : defaults[field]
    }

    return defaults[field];
  }
}